import { consoleLogger } from '@shared/logging/consoleLogger';
import { getUrlWithTransactionId } from '@shared/transactionId/getUrlWithTransactionId';
import { openIframe } from '@shared/iFrameHandler/openIFrame';

const iFrames: {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: any;
} = {};

export const openInIframe = ({
  iFrameUrl,
  iFrameId = 'GENERIC',
  isSrcDocUsed = false,
  suppressTransactionId = false,
}: {
  iFrameUrl: string;
  iFrameId?: string;
  isSrcDocUsed?: boolean;
  suppressTransactionId?: boolean;
  environment: string;
}): void => {
  if (!iFrameUrl) {
    consoleLogger.logError(
      `Missing iframe URL. Unable to create iFrame for ID ${iFrameId}`,
    );
    return;
  }

  const url: string = suppressTransactionId
    ? iFrameUrl
    : getUrlWithTransactionId(iFrameUrl);

  const attribute: string = isSrcDocUsed ? 'src' : 'srcdoc';

  const iFrameIdIndex: string | number = iFrameId as keyof typeof iFrames;
  if (iFrames[iFrameIdIndex]) {
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    isSrcDocUsed
      ? (iFrames[iFrameIdIndex].srcdoc = iFrameUrl)
      : (iFrames[iFrameIdIndex].src = url);
    iFrames[iFrameIdIndex].removeAttribute(attribute);
  } else {
    iFrames[iFrameIdIndex] = openIframe(
      isSrcDocUsed ? iFrameUrl : url,
      iFrameId,
      isSrcDocUsed,
    );
  }
};
